import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=f44f3538&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&lang=css&"
import style1 from "./supplier.vue?vue&type=style&index=1&id=f44f3538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44f3538",
  null
  
)

export default component.exports